<template>
  <div>
    <owner-note-form ref="ownerNoteFormModal"></owner-note-form>
    <trademarkSearch-owner-form ref="trademarkSearchOwnerForm" :getTrademarkSearchOwnerList="getTrademarkSearchOwnerList" :trademarkSearchId="this.trademarkSearchId"></trademarkSearch-owner-form>
    <b-row>
      <b-col class="col-12">
        <div style="float:right;" class="custom-search d-flex justify-content-end">
          <b-form-group>
            <div class="d-flex align-items-center">
              <b-button style="float:right;" size="sm" @click="getInfo()" variant="outline-primary"
                >{{ $t('trademarkSearchOwner.add') }}</b-button>
            </div>
          </b-form-group>
        </div>
      </b-col>
    </b-row>
    <!-- table -->
    <vue-good-table 
    id="trademarkSearchOwnerTable"
    ref="trademarkSearchOwnerTable" 
    :columns="columns" 
    :rows="rows"
    styleClass="vgt-table condensed tableSize"
    :select-options="{
      enabled: false,
      selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
      selectionInfoClass: 'custom-class',
      selectionText: 'rows selected',
      clearSelectionText: 'clear',
      disableSelectInfo: true, // disable the select info panel on top
      selectAllByGroup: true, // when used in combination with a grouped table, add a checkbox in the header row to check/uncheck the entire group
    }" 
      theme="my-theme">
      <div slot="emptystate">
        {{ $t('dataTable.data_not_found') }}
      </div>
      <!-- Row: Table Row -->
      <template slot="table-column" slot-scope="props">
        <span v-if="props.column.field === 'clientName'" class="text-nowrap">
          {{ $t('trademarkSearchOwner.name') }}
        </span>
        <span v-else-if="props.column.field === 'process'" class="text-nowrap">
          {{ $t('others.process') }}
        </span>
      </template>
    <template slot="table-row" slot-scope="props">
      <span v-if="props.column.field === 'process'">
        <span>
          <b-button v-b-tooltip.html :title="$t('trademarkSearchOwner.note')" variant="light" class="btn-icon mb-1 ml-1"
            size="sm" @click="getOwnerNoteInfo(props.row.clientId)">
            <feather-icon icon="AlignRightIcon" />
          </b-button>
          <b-button v-b-tooltip.html :title="$t('trademarkSearchOwner.show_owner')" variant="info" class="btn-icon mb-1 ml-1"
            size="sm" @click="getShowOwner(props.row.clientId)">
            <feather-icon icon="UsersIcon" />
          </b-button>
          <b-button v-b-tooltip.html :title="$t('others.delete')" variant="warning" class="btn-icon mb-1 ml-1"
            size="sm" @click="deleted(props.row)">
            <feather-icon icon="XIcon" />
          </b-button>
        </span>
      </span>
    </template>
    </vue-good-table>
  </div>
</template>

<script>
export default {
  props: {
    trademarkSearchId: Number,
    getOwnerInfo: {type: Function},
  },
  data() {
    return {
      dir: false,
      columns: [
        {
          label: this.$t('trademarkSearchOwner.name'),
          field: `clientName`,
        },
        {
          label: 'Process',
          field: 'process',
          width: '15em'
        },
      ],
      rows: [],
      searchTerm: '',
    }
  },
  mounted() {
    this.getTrademarkSearchOwnerList()
  },
  methods: {
    async getInfo() {
        this.$refs.trademarkSearchOwnerForm.showInfo()
      },
    async getOwnerNoteInfo(clientId) {
      this.$refs.ownerNoteFormModal.getNoteListByClientId(clientId)        
    }, 
    async getShowOwner(clientId) {
      this.getOwnerInfo(clientId)      
    }, 
    async deleted(data) {
      data = { id: data.id }
      const controller = { name: 'TrademarkSearchOwner' }
      const payload = { data: data, controller: controller }
      this.$DeleteConfirm().then(result => {
        if (result.value) {
          this.$store.dispatch('moduleAuth/delete', payload).then((response) => {
            if (response.data.resultStatus == true) {
              this.$DeleteAlert()
              this.getTrademarkSearchOwnerList()
            } else {
              this.$WarningAlert(response.data.resultMessage)
              this.getTrademarkSearchOwnerList()
            }
          })
        }
      })
    },
    getTrademarkSearchOwnerList() {
      this.rows = [] 
      const data = { id: this.trademarkSearchId }
      const controller = { name: 'TrademarkSearchOwner', actionName:'GetTrademarkSearchOwnerListByTrademarkSearchId' }
      const payload = { data: data, controller: controller }
      this.$store.dispatch('moduleAuth/customService', payload).then((response) => {
        if (response.data.resultStatus == true) {
          response.data.trademarkSearchOwnerList.forEach(element => {
            this.rows.push(element)
          })
        }
        else {
          this.$WarningAlert(response.data.resultMessage)
        }
      }
      )
    },
  },
}
</script>
<style lang="scss" >
  .tableSize {
    font-size: 13px!important;
    border-collapse: collapse;
    width: 100%;
    max-width: 100%;
    table-layout: auto;
}
</style>
